// 请求内容和接口名都加密
import axios from "axios";
import Vue from "vue";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import customConfig from "@/config/config";

let request = axios.create({
    method: "post",
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});

function generateAesKey() {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let key = '';
    for (let i = 0; i < 16; i++) {
        key += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return key;
}

function aesEncrypt(data, key) {
    let keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    let dataStr = typeof data === 'string' ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(dataStr, keyUtf8, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    }).toString();
}

function rsaEncrypt(data, publicKey) {
    let encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(data);
}

// 公钥缓存（含过期时间）
const publicKeyCache = {
    key: '',
    expiresAt: 0, // 毫秒时间戳
};

// 获取公钥（缓存时间：2.5 小时）
async function getGlobalPublicKey() {
    const now = Date.now();
    if (publicKeyCache.key && publicKeyCache.expiresAt > now) {
        return publicKeyCache.key;
    }

    try {
        const res = await axios.post(customConfig.backHost + '/ucUser/getPublicKey');
        if (res.data?.code === 200 && res.data.data) {
            publicKeyCache.key = res.data.data;
            publicKeyCache.expiresAt = now + 20 *  60 * 1000; // 20分钟
            return publicKeyCache.key;
        } else {
            throw new Error('获取公钥失败');
        }
    } catch (err) {
        throw new Error('获取公钥异常: ' + err.message);
    }
}

import router from '../router/index';
let _this = new Vue({ router });

request.interceptors.request.use(
    async config => {

        let token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `${token}`;
        }

        // 1. 获取公钥
        const publicKey = await getGlobalPublicKey();
        const aesKey = generateAesKey();
        const encryptedAesKey = rsaEncrypt(aesKey, publicKey);
        if (!encryptedAesKey) {
            _this.$message.error('AES密钥加密失败');
            return Promise.reject(new Error('AES密钥加密失败'));
        }

        // 2. 提取原始路径
        const realUrl = config.url.replace(customConfig.backHost, "");
        const encryptedPath = aesEncrypt(realUrl, aesKey);

        // 3. 构造业务加密数据
        const bodyStr = typeof config.data === 'string' ? config.data : JSON.stringify(config.data);
        const encryptedPayload = aesEncrypt(bodyStr, aesKey);

        // 4. 替换为统一网关地址
        config.url = customConfig.backHost + "/gateway/request";
        config.data = JSON.stringify({
            a: encryptedPath,
            b: encryptedPayload
        });

        config.headers['X-AES-Key'] = encryptedAesKey;
        config.headers['Authorization'] = `${token}`;
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';

        return config;
    },
    error => Promise.reject(error)
);

request.interceptors.response.use(
    response => {
        let data = response.data;
        if (data.code === 200) {
            return data;
        } else {
            return data;
        }
    },
    error => {
        if (error.response?.data?.code == 500) {
            _this.$message.error(error.response.data.msg);
        } else {
            _this.$message.error('后端连接异常');
        }
        return Promise.reject(error);
    }
);

export default request;
